import { StorageManager } from '@/types'

class Storage implements StorageManager {
  safeParse(value: string | null, defaultValue?: unknown): unknown {
    if (value === null || value === undefined) return defaultValue

    try {
      return JSON.parse(value)
    } catch {
      return value
    }
  }

  safeStringify(value: unknown): string {
    try {
      return JSON.stringify(value)
    } catch {
      return String(value)
    }
  }

  setLocal(key: string, value: unknown): void {
    try {
      localStorage.setItem(key, this.safeStringify(value))
    } catch (error) {
      console.error('Error setting local storage:', error)
    }
  }

  getLocal(key: string, defaultValue?: unknown): unknown {
    try {
      const item = localStorage.getItem(key)
      if (item === null) return defaultValue

      const parsed = this.safeParse(item, defaultValue)
      return parsed ?? defaultValue
    } catch (error) {
      console.error('Error getting local storage:', error)
      return defaultValue
    }
  }

  removeLocal(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing from local storage:', error)
    }
  }

  clearLocal(): void {
    try {
      localStorage.clear()
    } catch (error) {
      console.error('Error clearing local storage:', error)
    }
  }

  setSession(key: string, value: unknown): void {
    try {
      sessionStorage.setItem(key, this.safeStringify(value))
    } catch (error) {
      console.error('Error setting session storage:', error)
    }
  }

  getSession(key: string, defaultValue?: unknown): unknown {
    try {
      const item = sessionStorage.getItem(key)
      if (item === null) return defaultValue

      const parsed = this.safeParse(item, defaultValue)
      return parsed ?? defaultValue
    } catch (error) {
      console.error('Error getting session storage:', error)
      return defaultValue
    }
  }

  removeSession(key: string): void {
    try {
      sessionStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing from session storage:', error)
    }
  }

  clearSession(): void {
    try {
      sessionStorage.clear()
    } catch (error) {
      console.error('Error clearing session storage:', error)
    }
  }
}

export default new Storage()
